import React from "react";
import "./Loading-sm.css";

const LoadingSm = () => {
  return (
    <div className="loader">
    </div>
  );
};

export default LoadingSm;


// WEBPACK FOOTER //
// ./src/common/Loading/Loading-sm.js